import { Box } from '@mui/material';

import type { FactsheetDetails } from '@/features/Factsheet/types';
import { parseVersionHistoryText } from '@/features/Factsheet/utils/versionHistory';

import UnregisteredBanner from '../UnregisteredBanner';
import TextLinesDisplay from './TextLinesDisplay';

interface QualitySpecTabProps {
  factsheet: FactsheetDetails;
  isAuthenticated: boolean;
}

const QualitySpecTab = ({ factsheet, isAuthenticated }: QualitySpecTabProps) => {
  if (!isAuthenticated) {
    return (
      <Box sx={{ pt: 5 }}>
        <UnregisteredBanner />
      </Box>
    );
  }

  const qualitySpecLines = parseVersionHistoryText(factsheet, 'qualitySpecification');

  return (
    <Box>
      <TextLinesDisplay lines={qualitySpecLines} />
    </Box>
  );
};

export default QualitySpecTab;
